import {
	type BuildGenerateReportRequestInput,
	type GenerateReportRequest,
	REPORT_TYPE,
	type ReportType,
} from "../types/generate-report-request";

type FilterListKey =
	| "vehicleIds"
	| "driverIds"
	| "eventTypeIds"
	| "expenseTypeIds"
	| "templateIds";

const FILTERS_BY_REPORT: Record<ReportType, readonly FilterListKey[]> = {
	[REPORT_TYPE.Events]: ["vehicleIds", "driverIds", "eventTypeIds"],
	[REPORT_TYPE.Expenses]: ["vehicleIds", "expenseTypeIds"],
	[REPORT_TYPE.Trips]: ["vehicleIds", "driverIds"],
	[REPORT_TYPE.Infractions]: ["vehicleIds"],
	[REPORT_TYPE.Checklist]: ["vehicleIds", "templateIds"],
	[REPORT_TYPE.Vehicles]: [],
};

/**
 * Builds a report-specific payload. Unsupported filter lists are omitted
 * (sending them with items causes 400). Empty lists are also omitted (empty = all).
 */
export function buildGenerateReportRequest(
	input: BuildGenerateReportRequestInput
): GenerateReportRequest {
	const isVehiclesReport = input.type === REPORT_TYPE.Vehicles;
	const pullAllSinceStart = isVehiclesReport
		? false
		: (input.pullAllSinceStart ?? false);

	const request: GenerateReportRequest = {
		type: input.type,
	};

	if (!isVehiclesReport) {
		request.pullAllSinceStart = pullAllSinceStart;
	}

	if (!pullAllSinceStart) {
		const initialDate = input.initialDate ?? null;
		const finalDate = input.finalDate ?? null;

		if (initialDate || finalDate) {
			request.initialDate = initialDate;
			request.finalDate = finalDate;
		}
	}

	for (const field of FILTERS_BY_REPORT[input.type]) {
		const ids = input[field];
		if (ids && ids.length > 0) {
			request[field] = ids;
		}
	}

	return request;
}
